module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "day-cal"
  }, [_c('div', {
    staticClass: "day-cal__container"
  }, [_c('ul', {
    staticClass: "day-cal__time-sidebar"
  }, _vm._l((_vm.hoursInLocale), function(n) {
    return _c('li', {
      staticClass: "time-hours"
    }, [_vm._v("\n          " + _vm._s(n) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "day-cal__time-background"
  }, [_vm._l((_vm.hours.length * 2), function(n) {
    return _c('li', {
      staticClass: "time-slot",
      class: {
        today: _vm.isToday
      }
    })
  }), _vm._v(" "), (_vm.isToday) ? _c('now-indicator', {
    attrs: {
      "start": _vm.start,
      "slotHeight": _vm.slotHeight
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "day-cal__event-container"
  }, [_vm._l((_vm.correctEvents), function(event) {
    return [_c('cal-event', {
      attrs: {
        "event": event,
        "start": _vm.start,
        "i18n": _vm.i18n
      },
      on: {
        "eventClicked": _vm.onTap
      }
    })]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d8163be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/DayCal/DayCal.vue
// module id = 2057
// module chunks = 1